import type { TaskModalTask } from "@common/types";
import type { CurrencyPreference } from "@common/types/User";
import { createContext } from "react";

export type OpenCompletionModalParams = {
  task: Pick<
    TaskModalTask,
    "id" | "name" | "taskType" | "cropName" | "cropId" | "gardenCropId"
  >;
  unitPreference: "imperial" | "metric";
  currencyPreference: CurrencyPreference;
  selectedDate?: string;
  showInventory: boolean;
  showHarvestRecord: boolean;
  isOverdue: boolean;
  onSuccess?: () => void;
};

type CompletionModalContextType = {
  openCompletionModal: (params: OpenCompletionModalParams) => void;
};

export const CompletionModalContext = createContext<CompletionModalContextType | null>(
  null
);
